import http from '../common/http'

export const preview = (param) =>{
  param = param.type?param:{...param,type:'project'}
  return http.requestGetFile('/file/preview',param);
}
export const download = (param,callback) =>{
  return http.requestGetFile('/file/download',param,callback);
}
export const importFile = (param) =>{
  return http.requestPostForm('/file/importFile',param);
}

